import { render, staticRenderFns } from "./#latest.vue?vue&type=template&id=699dc67a&"
import script from "./#latest.vue?vue&type=script&lang=js&"
export * from "./#latest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports